import { useEffect } from 'react';

// Refresh the bell when a server-side notification is broadcast. The bell still
// refreshes on hover as a fallback for notifications created while this tab was
// disconnected.
const useNotificationRefresh = (cable, onNotification) => {
  useEffect(() => {
    if (!cable || !onNotification) return undefined;

    const subscription = cable.subscriptions.create(
      { channel: 'NotificationsChannel' },
      { received: onNotification },
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [cable, onNotification]);
};

export default useNotificationRefresh;
